import React from "react";
import { Typography } from "@mui/material";
import { defineMessage, FormattedMessage, MessageDescriptor } from "react-intl";

const NotSetValue: React.FC<{
    label?: MessageDescriptor
    labelValues?: Record<string, any>
}> = (props) => {
    const {
        label = defineMessage({
            id: "not-set",
            defaultMessage: "Not set"
        }),
        labelValues
    } = props;

    return (
        <Typography
            sx={{
                color: "text.disabled",
                fontStyle: "italic",
            }}
        >
            <FormattedMessage {...label} values={labelValues} />
        </Typography>
    );
};

export default NotSetValue;
